import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useResizeListener } from '~/hooks/common';
import { useTrackClickEvents } from '~/hooks/common';
import useDataDogRUM from '~/hooks/common/useDataDogRUM';
import setLocalBrowserCookieId from '~/pages-utils/setLocalBrowserCookieId';

export default function VendingMachineData() {
  useDataDogRUM();
  setLocalBrowserCookieId();
  useTrackClickEvents();
  useResizeListener(legacySizes);

  return null;
}
